import React from 'react'
import { Box, IconButton, Tooltip } from "@mui/material"
import { boxIconButton, styleImage } from "./sxListaItensOrigem"
import mercadolivre from '../../../../../Assets/icones/mercadolivrenovo.png'
import correios from '../../../../../Assets/icones/correios2.png'
import shein from '../../../../../Assets/icones/shein.svg'
import shopee from '../../../../../Assets/icones/shopee.svg'
import amazon from '../../../../../Assets/icones/amazon1.png'
import magalu from '../../../../../Assets/icones/magalu.svg'
import outropng from '../../../../../Assets/icones/outropng.png'

const ListaItensOrigem = ({ selectedOrigin, setSelectedOrigin, setFormData }) => {
    const handleChangeOrigem = (e) => {
        const origin = e.currentTarget.getAttribute('data-origin')
        setFormData((prevFormData) => ({ ...prevFormData, id_encomenda_origem: origin }))
        setSelectedOrigin(origin)
    }

    const getButtonStyle = (originValue) => {
        const isSelected = originValue == selectedOrigin
        return styleIconButton(isSelected, originValue)
    }

    const styleIconButton = (selected, value) => {
        return {
            borderRadius: '5px',
            backgroundColor: selected ? '#9c27b0cc' : 'inherit',
            width: value === '7' ? '85px' : '65px',
            height: '51px'
        }
    }

    const itemsOrigin = [
        { value: 1, name: 'Mercado Livre', icon: mercadolivre },
        { value: 2, name: 'Correios', icon: correios },
        { value: 3, name: 'Shein', icon: shein },
        { value: 4, name: 'Shopee', icon: shopee },
        { value: 5, name: 'Amazon', icon: amazon },
        { value: 6, name: 'Magalu', icon: magalu },
        { value: 7, name: 'Outro', icon: outropng }
    ]

    return (
        <>
            {
                itemsOrigin.map((item, index) => {
                    return (
                        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }} key={index}>
                            <Box sx={boxIconButton}>
                                <Tooltip title={item.name} arrow>
                                    <IconButton
                                        data-origin={item.value}
                                        aria-label="fingerprint"
                                        color="secondary"
                                        sx={getButtonStyle(item.value)}
                                        onClick={handleChangeOrigem}
                                    >
                                        <img style={styleImage} src={item.icon}></img>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <span style={{ fontSize: '9px' }}>{item.name}</span>
                        </Box>
                    )
                })
            }
        </>
    )
}

export default ListaItensOrigem
